import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { format } from "date-fns";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface IBenchHistory {
    historyID?: number,
    submission_ID?: number,
    status?: string,
    added_By?: number,
    user_Name?: string,
    createdOn?: Date
}

interface Iprops {
    submission_ID: number,
    consultant_Name?: string,
    open: boolean,
    hideDialog: () => void,
    toast: any
}

export const History = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IBenchHistory>, loading: boolean });

    useEffect(() => {
        if (props.submission_ID) loadTableData();
    }, [props.submission_ID]);

    const loadTableData = async () => {
        setTableData({ tableData: [], loading: true });
        const response = await Fetch("Consultant_Bench/history", "GET", null, `submission_ID=${props.submission_ID}`, props.toast);
        if (response) {
            const data: Array<IBenchHistory> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: [], loading: false });
    }

    const status_Date = (rowData: IBenchHistory) => {
        let date;
        if (rowData.createdOn) date = format(new Date(rowData.createdOn), 'dd/MM/yyyy hh:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const onHide = () => {
        props.hideDialog();
        setTableData({ tableData: [], loading: false });
    }

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={`History found against SubmissionID - ${props.submission_ID} (${props.consultant_Name})`} modal className="p-fluid" onHide={onHide}>
            <DataTable size="small" stripedRows
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="status" header="Status" />
                {/* <Column field="createdOn" header="Updated On" body={status_Date} /> */}
                <Column field="createdOn" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.createdOn, 'dd/MM/yyyy', DateFormat, true) } />
                <Column field="user_Name" header="Updated By" />
            </DataTable>
        </Dialog>
    );
}
